import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getGlobalSearchLoaded,
  getGlobalSearchLoading,
  getGlobalSearchQuery,
  getGlobalSearchResults,
  getProductsLoaded,
  getProductsLoading,
  getSearchQuery,
  getSearchResults,
  Metafield,
  Product,
  ProductThumb,
} from 'src/app/shop';

@Component({
    selector: 'app-search-results',
    templateUrl: './search-results.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchResultsComponent {
  private store = inject(Store);

  searchResults$ = this.store.select(getGlobalSearchResults);
  loading$ = this.store.select(getGlobalSearchLoading);
  searchQuery$ = this.store.select(getGlobalSearchQuery);
  loaded$ = this.store.select(getGlobalSearchLoaded);

  placeholderImageUrl = 'https://cdn.shopify.com/s/files/1/0622/3881/8561/collections/placeholder.png';

  getCustomLabel(product: ProductThumb): Metafield | undefined {
    // Find it in single or multiple metafield lists
    //const detailLabel = product?.metafields?.find(a => a?.key === 'custom_label');
    const cardLabel = product?.metafield?.key === 'custom_label' ? product?.metafield : undefined;

    return cardLabel;
  }
}
